<script setup lang="ts">
const props = defineProps<{
  block?: boolean
  mini?: boolean
}>()

const url = props.mini
  ? 'https://resource.mfuns.net/imgs/logo_mini.svg'
  : 'https://resource.mfuns.net/imgs/logo.svg'
</script>

<template>
  <nuxt-link
    class="m-logo"
    :class="{ block }"
    to="/"
    no-prefetch
    :style="{
      '-webkit-mask': `url(${url}) no-repeat left`,
      mask: `url(${url}) no-repeat left`,
      width: mini ? '28px' : '132px'
    }"
    aria-label="Logo, Click to go to home page"
  />
</template>
